import React from 'react';
import Typography from '@material-ui/core/Typography';
import { List, ListItem, ListItemText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import './style.css';

const styles = {
    root: {
        color: '#FFFFFF',
        fontSize: '1rem',
        textAlign: 'left',
        width: '100%',
    },
    listItem: {
        padding: '5px 0px',
        fontSize: '12px',
    },
    listItemText: {
        margin: '0px',
    },
    aboutSigniant: {
        color: '#FFFFFF',
        fontSize: '14px',
        fontFamily: 'Roboto',
        letterSpacing: '0.5px',
        marginTop: '5px',
        marginBottom: '20px',
    },
    aboutSigniantTitle: {
        fontSize: '24px',
        color: '#FFFFFF',
    },
};

const aboutLinks = [
    {
        primary: 'Support',
        href: 'https://support.signiant.com/hc/en-us',
    },
    {
        primary: 'API Documentation',
        href: 'https://developer.signiant.com/',
    },
    {
        primary: 'Product Updates',
        href: 'https://www.signiant.com/tag/product-updates/',
    },
    {
        primary: 'Case Studies',
        href: 'https://www.signiant.com/resources/case-studies/',
    },
    {
        primary: 'Core Technology',
        href: 'https://www.signiant.com/technology/',
    },
];

const Footer = ({ classes }) => {
    const { root, listItem, aboutSigniant, aboutSigniantTitle, listItemText } = classes;
    return (
        <div className={'container hidden-print'}>
            <div className={'footerAbout'}>
                <Typography classes={{ root: aboutSigniantTitle }} variant={'caption'}>
                    About Signiant
                </Typography>
                <Typography classes={{ root: aboutSigniant }} variant={'caption'}>
                    Signiant’s intelligent file movement software helps the world’s top content creators and
                    distributors ensure fast, secure delivery of large files over public and private networks. Built on
                    Signiant’s patented technology, the company’s on-premises software and SaaS solutions move petabytes
                    of high-value data every day between users, applications and systems with proven ease.
                </Typography>
                <a
                    href={'https://www.signiant.com/'}
                    target={'_blank'}
                    style={{ color: 'white', fontSize: 12 }}
                    rel="noreferrer"
                >
                    LEARN MORE
                </a>
            </div>
            <div className={'footerLinks'}>
                <Typography classes={{ root }} variant={'OVERLINE'} style={{ marginTop: -55 }}>
                    Quick Links
                </Typography>
                <List className={'list-items'} classes={{ root }}>
                    {aboutLinks.map((data, index) => (
                        <ListItem
                            key={index}
                            classes={{ root: listItem }}
                            button={true}
                            component={'a'}
                            href={data.href}
                            target={'_blank'}
                        >
                            <ListItemText disableTypography classes={{ root: listItemText }} primary={data.primary} />
                        </ListItem>
                    ))}
                </List>
            </div>
        </div>
    );
};

export default withStyles(styles)(Footer);
